import { useCallback } from "react"
import { IProdutoClienteAndTipoConsumo } from "../../application/models"
import { useAxiosInstances } from "../axios-instance"

export const useTipoConsumoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const getAllProdutosAndTipoConsumosApi = useCallback(async (data: {
        IdCliente?: number
    }): Promise<{
        produtoClienteTipoConsumo: IProdutoClienteAndTipoConsumo[]
    }> => {
        try {
            const result = await axiosAuthInstance.get('/produto/produtoTipoConsumo', {
                params: {
                    IdCliente: data.IdCliente
                }
            })

            return {
                produtoClienteTipoConsumo: result.data.produtoClienteTipoConsumo
            }
        }

        catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const getProdutoClienteByIdClienteApi = useCallback(async (data: {
        IdCliente: number
        Ativo?: boolean
    }): Promise<{
        IdProduto: number
        IdProdutoCliente?: number
        IdTipoConsumo: number
        TipoConsumoAtivo?: boolean
    }[]> => {
        try {
            const result = await axiosAuthInstance.get('/produtoCliente/produtosCliente', {
                params: {
                    IdCliente: data.IdCliente
                }
            })
            return result.data.produtosTipoConsumo
        }
        catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const getProdutoTipoSConsumoPadraoApi = useCallback(async (): Promise<any[]> => {
        try {
            const result = await axiosAuthInstance.get('/produto-tipo-consumo')
            return result.data.TiposConsumoPadrao || []
        }
        catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    return {
        getAllProdutosAndTipoConsumosApi,
        getProdutoClienteByIdClienteApi,
        getProdutoTipoSConsumoPadraoApi
    }
}
